import React, { useEffect, useRef, useState } from 'react';
import './FileComment.scss';
import { connect } from 'react-redux';
import ApiResources from '../../helpers/APIResource';
import { Alert, Button, Form, Spinner } from 'react-bootstrap';
import { T } from '../../helpers/Language';
import { FileElement } from '../../helpers/Drive';
import UserAnalytic from '../../helpers/UserAnalytic';

export const FileCommentItem = ({
    comment,
    connectedUser,
    creator,
    lastUserId,
}) => {
    const isEntityOwner =
        (creator || {}).entityId === (connectedUser || {}).entityId;
    const isSameUser = lastUserId === (creator || {}).userId;
    const userIsAuthor = creator.userId === (connectedUser || {}).userId;
    const fullname = userIsAuthor
        ? 'You'
        : `${creator.firstname} ${creator.lastname}`;
    return (
        <div
            id={comment.id}
            className={[
                'f-comment-item',
                isEntityOwner ? 'is-owner' : 'is-other',
            ].join(' ')}
        >
            <div className="fci-container">
                {isSameUser ? null : <div className="fci-name">{fullname}</div>}
                <div className="fci-message-bubble">{comment.text}</div>
                <div className="fci-message-date">
                    {FileElement.toHumaneReadableDate(comment.createdAt)}
                </div>
            </div>
        </div>
    );
};

export const FileComments = ({
    fileElement,
    userProfile,
    appState,
    onSendComment,
    fallback,
    loading,
}) => {
    const [commentMessage, setCommentMessage] = useState('');
    const [lastFileElementId, setLastFileElementId] = useState(null);
    const commentViewRef = useRef(null);
    useEffect(() => {
        if (!fileElement) return;
        if (lastFileElementId === fileElement.id) {
            setLastFileElementId(null);
            return;
        }
        if (commentViewRef.current && !lastFileElementId) {
            const c = commentViewRef.current;
            const height = c.scrollHeight;
            c.scrollTo({
                top: height,
                behavior: 'smooth',
            });
            setLastFileElementId(fileElement.id);
        }
    }, [commentViewRef.current, fileElement]);
    const Fallback = fallback || null;
    if (!fileElement || !fileElement.createdBy)
        return Fallback ? <Fallback /> : <></>;
    const comments = Array.isArray(fileElement.comments)
        ? fileElement.comments
        : [];
    const handleSubmit = async (e) => {
        e.preventDefault();
        UserAnalytic.event({
            category: 'drive_file_comment',
            action: 'Add new comment on file',
        });
        const ret = await onSendComment(commentMessage);
        setCommentMessage('');
    };
    let lastUserId = null;
    return (
        <>
            <div className="f-comment-list p-3" ref={commentViewRef}>
                {comments.length === 0 ? (
                    <div className="p-5 text-center">
                        <Alert>
                            {T('DRIVE_DETAILS_LABEL_EMPTY_DISCUSSION')}
                        </Alert>
                    </div>
                ) : null}
                {comments.map((elm) => {
                    const tmpLastUserId = lastUserId;
                    lastUserId = elm.createdBy;
                    console.log('USER ID', ApiResources.getUser(elm.createdBy));

                    return (
                        <FileCommentItem
                            key={elm.id}
                            connectedUser={userProfile}
                            lastUserId={tmpLastUserId}
                            creator={ApiResources.getUser(elm.createdBy)}
                            comment={elm}
                        />
                    );
                })}
            </div>
            <div className="p-3">
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="form.Comment">
                        <Form.Label>
                            {T('DRIVE_DETAILS_LABEL_MESSAGE')}
                        </Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={commentMessage}
                            onChange={(e) => setCommentMessage(e.target.value)}
                        />
                    </Form.Group>
                    <Button variant="primary" type="submit">
                        {loading ? (
                            <Spinner size="sm" />
                        ) : (
                            T('GEN_LABEL_SUBMIT')
                        )}
                    </Button>
                </Form>
            </div>
        </>
    );
};

const mapStateToProps = (appState) => ({
    userProfile: appState.userProfile,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(FileComments);
